import { c as _c } from "react/compiler-runtime";
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { BCalculatedPriceItemTypeEnum } from '@/types/backend';
import { formatPrice } from '@winelidays/wld-tsx-2/utils';
const SegmentationDetailLine = (t0) => {
    const $ = _c(12);
    const { type, count, price, name, hasSpecialTariffs } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    const label = type === BCalculatedPriceItemTypeEnum.Default && hasSpecialTariffs ?
        `${name} ${translate("practical.price.standard-tariff")}` :
        name;
    let t1;
    if ($[0] !== count || $[1] !== currencySymbol || $[2] !== price || $[3] !== translate) {
        t1 = translate("availability.calculated_price.value", { count, price: formatPrice(price), currencySymbol });
        $[0] = count;
        $[1] = currencySymbol;
        $[2] = price;
        $[3] = translate;
        $[4] = t1;
    }
    else {
        t1 = $[4];
    }
    const value = t1;
    let t2;
    if ($[5] !== label) {
        t2 = <span className="text-gray-400 auto-ellipsis mr-2">{label}</span>;
        $[5] = label;
        $[6] = t2;
    }
    else {
        t2 = $[6];
    }
    let t3;
    if ($[7] !== value) {
        t3 = <span className="whitespace-nowrap">{value}</span>;
        $[7] = value;
        $[8] = t3;
    }
    else {
        t3 = $[8];
    }
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = <div className="flex flex-row justify-between py-1">{t2}{t3}
    </div>;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    }
    else {
        t4 = $[11];
    }
    return t4;
};
export default SegmentationDetailLine;
